/**Hàm kiểm tra giờ có phải là giờ cao điểm của Vnpost không (từ 8h - 21h) */
export const isVnpostRushHour = (time = new Date()) => {
  const today = new Date(time);

  const currentTime = today.getTime();

  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth();
  const currentDate = today.getDate();

  const RUSH_HOURS = [
    [
      new Date(currentYear, currentMonth, currentDate, 8, 0, 0, 0).getTime(),
      new Date(currentYear, currentMonth, currentDate, 21, 0, 0, 0).getTime(),
    ],
  ];

  for (let i = 0; i < RUSH_HOURS.length; i++) {
    const rushHour = RUSH_HOURS[i];
    if (currentTime >= rushHour[0] && currentTime < rushHour[1]) {
      return true;
    }
  }

  return false;
};

export const downloadFileByUrl = (url) => {
  const link = document.createElement("a");
  link.target = "_blank";
  link.href = url;
  link.click();
};
